// Where a punch is allowed to come from.
//
// The attendance policy the product states, in its own words: "Clock-IN and
// Clock-OUT must be done from an office computer, tablet, or laptop (fraud
// prevention). Mobile devices are not permitted."
//
// That rule lived as a copy-pasted helper in two files — Attendance.js and
// CheckInWall.js — and, until the phone fork was folded away, a third screen
// (MobileAttendance) punched straight through to the API without consulting
// either copy. The server does not gate on device at all, so this is the only
// place the policy exists. One copy, so the two screens cannot drift and the
// next screen that needs it has somewhere to import from.
//
// Both halves are required on purpose: the user agent alone calls an iPad a
// phone, and a narrow window alone calls a resized laptop one.
export function isMobilePhone() {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /Android.*Mobile|iPhone|iPod|Windows Phone|BlackBerry|Opera Mini|IEMobile/i.test(ua)
    && window.innerWidth < 768;
}

export const PUNCH_DEVICE_MESSAGE =
  'Clock-in and clock-out must be done from an office computer, tablet, or laptop (fraud prevention). Mobile devices are not permitted.';

// Whether a phone may punch, given the effective attendance rules.
//
// The policy is now a founder-editable rule (`allowMobilePunch`, default off)
// rather than a constant, and the server enforces the same rule on
// POST /attendance/clock-in — this only decides what the UI offers. Rules that
// have not loaded yet must NOT read as permission, so an absent rules object
// keeps the phone blocked.
export function mobilePunchAllowed(rules) {
  return !!(rules && Number(rules.allowMobilePunch));
}
